import React from 'react';
interface CTAButtonProps {
  text: string;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  text,
  className = '',
  onClick
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      const element = document.getElementById('oferta');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <button onClick={handleClick} className={`${`w-full md:w-auto bg-brand-yellow hover:bg-brand-yellowHover text-black font-bold py-4 px-8 rounded-full shadow-[0_4px_14px_0_rgba(251,191,36,0.39)] transition-all duration-200 text-base md:text-xl flex items-center justify-center gap-2 hover:scale-105 active:scale-95 ${className}`} text-[14px]`} data-id="element-100">
      {text}
    </button>;
}